import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import LotteryPage from '../../components/lottery';
import { getClubLoadingError, hasClubLoaded, isClubLoading } from '../../store/contact/selectors';
import ClubRouter from '../../lib/routing';
import Club404 from '../../components/errors/club-404';
import { withTranslation } from '../../lib/i18n';

class LotteryPageController extends React.Component {
  static async getInitialProps({ query }) {
    const { officialId } = query;
    const initialProps = {
      activeSection: 'lottery',
      namespacesRequired: ['common'],
      officialId: officialId ? parseInt(officialId, 10) : null,
      pageType: 'lottery',
    };

    return initialProps;
  }

  componentDidMount() {
    const { official, officialId } = this.props;

    if (officialId && !official) {
      ClubRouter.replaceClubRoute('lottery');
    }
  }

  render() {
    const { club } = this.props;
    if (!club.fundraisingClub) {
      return <Club404 club={club} />;
    }

    return (
      <LotteryPage
        club={club}
        clubName={club.name}
        beEthicalCode={club.fundraisingClub.beEthicalCode}
        causeInformation={club.fundraisingClub.causeInformation}
      />
    );
  }
}

LotteryPageController.defaultProps = {
  official: null,
  officialId: null,
};

LotteryPageController.propTypes = {
  official: PropTypes.shape({
    id: PropTypes.number.isRequired,
  }),
  officialId: PropTypes.number,
  club: PropTypes.shape({
    id: PropTypes.number.isRequired,
    fundraisingClub: PropTypes.shape({
      beEthicalCode: PropTypes.string,
      causeInformation: PropTypes.string,
    }),
    name: PropTypes.string,
  }).isRequired,
};

const mapStateToProps = (state, ownProps) => ({
  isLoading: isClubLoading(state, ownProps.club.id),
  loadingError: getClubLoadingError(state, ownProps.club.id),
  previouslyLoaded: hasClubLoaded(state, ownProps.club.id),
});

const dispatchToProps = {};

export default connect(
  mapStateToProps,
  dispatchToProps,
)(withTranslation(['fundraisingClub'])(LotteryPageController));
